'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled } from '@mui/material/styles';
import MaterialInputLabel from '@mui/material/InputLabel';
const StyledInputLabel = styled(MaterialInputLabel)(({ theme }) => ({
    color: theme.tokens.FuelColorGray900,
    fontSize: theme.typography.button.fontSize,
    fontWeight: theme.typography.button.fontWeight,
    marginBottom: theme.spacing(1),
    '&.Mui-focused': {
        color: theme.tokens.FuelColorTextPrimary
    },
    '&.MuiInputLabel-shrink': {
        transform: 'none',
        position: 'relative',
        height: 'auto',
        overflow: 'hidden',
        lineHeight: theme.spacing(5),
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    '&.Mui-error': {
        color: theme.tokens.FuelColorGray900
    },
    '& .MuiInputLabel-asterisk': {
        color: theme.palette.error.main
    }
}));
export const InputLabel = React.forwardRef(({ hiddenLabel, sx, ...props }, ref) => (_jsx(StyledInputLabel, { ...props, ref: ref, shrink: true, sx: [
        {
            display: hiddenLabel ? 'none' : 'block'
        },
        ...Array.isArray(sx) ? sx : [sx]
    ] })));
InputLabel.displayName = 'InputLabel';
